export default "__VITE_ASSET__CFpB37Tl__"